// PHASE 5: How important is eco-friendly design to you?
import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../../hooks/useUpdateMode'
import { saveAnswer } from '../../../utils/onboardingStorage'

const QUESTION_KEY = 'sustainabilityValue'

const OPTIONS = [
  {
    value: 'Essential priority',
    translationKey: 'pages.onboarding.v2.sustainabilityValue.options.essential',
    emoji: '🌍',
  },
  {
    value: 'Important factor',
    translationKey: 'pages.onboarding.v2.sustainabilityValue.options.important',
    emoji: '🌱',
  },
  {
    value: 'Nice to have',
    translationKey:
      'pages.onboarding.v2.sustainabilityValue.options.niceToHave',
    emoji: '👍',
  },
  {
    value: 'Not a priority',
    translationKey:
      'pages.onboarding.v2.sustainabilityValue.options.notPriority',
    emoji: '🤷',
  },
]

export default function SustainabilityValuePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How important is eco-friendly design to you?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  const buttons = OPTIONS.map((option) => ({
    text: `${option.emoji} ${t(option.translationKey)}`,
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.v2.sustainabilityValue.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
